import React, {useEffect, useState} from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {useParams} from 'react-router-dom';
import {baseUrl, formatDateTime, ipAddress, userLocation, userName} from '../../Univ.js'
function ChestPhysio(props) {
    const {ip_id} = useParams();
    const [ipData, setIpData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [chestData, setchestData] = useState([]);
    const [nurseData, setnurseData] = useState({
        "ip": '',
        "technique": '',
        "notes": '',
        "chest_time": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        fetchData();
    }, []);
    function fetchData() {
        axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
            .then(response => {
                setIpData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };
    useEffect(() => {
        fetchchestData();
    }, []);
    function fetchchestData() {
        axios.get(baseUrl + "view-chest-physio/" + ip_id + "/")
            .then(response => {
                setchestData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const formSubmit = (e) => {
        e.preventDefault();
        const technique = document.getElementById("technique").value;
        const notes = document.getElementById("notes").value;
        const chest_time = document.getElementById("chest_time").value;
        const _formData = new FormData();
        _formData.append('ip', ip_id);
        _formData.append('technique', technique);
        _formData.append('notes', notes);
        _formData.append('chest_time', chest_time);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        axios.post(`${baseUrl}chest-physio-create/`, _formData)
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'Notes Created Succesfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setnurseData({
                        ip: '',
                        notes: '',
                        chest_time: '',
                        status: '',
                        addedby: '',
                        ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = '/nurse-pat-view/' + ip_id + '/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed. Please try again later.',
                    'error'
                );
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-chest-physio/' + id + '/')
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                        });
                    setTimeout(() => {
                        window.location.href = ('/chest-physio/' + ip_id + '/');
                    }, 2000);
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i>
                Primary Consultant - Dr.{ipData.map(row => row.primary_consult.consultant)}
            </h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient</th>
                        <th>IP ID</th>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {ipData.map((patientData, index) => (
                        <tr>
                            <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail"
                                     style={{width: 120, height: 60}}/></td>
                            <td>{patientData.ip_id}</td>
                            <td>{patientData.pat.pat_id}</td>
                            <td>{patientData.pat.patient}</td>
                            <td>{patientData.pat.gender}</td>
                            <td>{patientData.pat.age}</td>
                            <td>{patientData.pat.mobile}</td>
                            <td>{formatDateTime(patientData.admit_date)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div>
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-user-nurse" aria-hidden="true" style={{color: 'red'}}></i>
                    Chest Physio
                </h3>
                <form>
                    <div className="row">
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Tempr" className="form-label">Technique: </label>
                            <select className="form-control"
                                    name="technique" id="technique">
                                <option>Select</option>
                                <option value="Manual">Manual</option>
                                <option value="Chest-Tapping">Chest-Tapping</option>
                                <option value="Vibrator">Vibrator</option>
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="Notes" className="form-label">Notes : </label>
                            <textarea
                                className="no-comma form-control"
                                tabIndex="0"
                                name="notes"
                                id="notes"
                                required
                                rows={7} // Increase the number of rows to 4
                                cols={90} // Increase the number of columns to 30
                            ></textarea>

                        </div>
                        <div className="col-md-3">
                            <label htmlFor="Notes Time" className="form-label">Notes Time : </label>
                            <DatePicker className="form-control" name="chest_time" id="chest_time"
                                        selected={selectedDateTime}
                                        onChange={handleDateTimeChange}
                                        dateFormat="yyyy-MM-dd h:mm"
                                        showTimeSelect
                                        timeIntervals={15}
                                        timeCaption="Time"
                            />
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                         className='ms-5 mb-5'>
                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
                    </div>
                </form>
                <div className="card card-body">
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                        <i className="fa-solid fa-user-nurse" aria-hidden="true" style={{color: 'red'}}></i>
                        Chest Physio History
                        <i className="fa-brands fa-discourse"></i>
                    </h3>
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Date</th>
                                <th>Technique</th>
                                <th>Notes</th>
                                <th>Delete</th>
                            </tr>
                            </thead>
                            <tbody>
                            {chestData.map((dis, index) => (
                                <tr>
                                    <td>{formatDateTime(dis.chest_time)}</td>
                                    <td>{dis.technique}</td>
                                    <td>{dis.notes}</td>
                                    <td>
                                        <button className="btn btn-danger" type="button"
                                                onClick={() => handleDelete(dis.id)}>
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default ChestPhysio;